export default {
      id: "flex-flexWrap-wrap-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-flexWrap-wrap-usage",
      toString: function () {
        return this.url;
      }
    }